<template>
  <div>
    <div v-if="this.solCdecAvailable">
      <v-data-table
        dense
        class="mr-2 elevation-2"
        multi-sort
        show-select
        v-model="selectedSolCdec"
        :headers="this.headersSolCdec"
        :items="this.itemsSolCdec"
        :options.sync="options"
        :footer-props="{ 'items-per-page-options': [20, 50, 100, -1] }"
        @toggle-select-all="handleToggleAll($event)"
      >
        <template v-slot:top>
          <br />
          <tr>
            <td>
              <div
                data-toggle="tooltip"
                data-placement="bottom"
                title="Effacer les filtres"
              >
                <v-icon class="fas fa-eraser" v-on:click="clearFilter"></v-icon>
              </div>
            </td>
            <td>
              <v-layout>
                <v-text-field
                  v-model="codeSite"
                  type="text"
                  label="Code site"
                ></v-text-field>

                <v-text-field
                  v-model="nomSite"
                  type="text"
                  label="Nom site"
                ></v-text-field>

                <v-text-field
                  v-model="nomEspeceOrigine"
                  type="text"
                  label="Nom espèce origine"
                ></v-text-field>

                <v-text-field
                  v-model="codeVarieteOrigine"
                  type="text"
                  label="Code variété origine"
                ></v-text-field>

                <v-text-field
                  v-model="nomVarieteOrigine"
                  type="text"
                  label="Nom variété origine"
                ></v-text-field>

                <v-text-field
                  v-model="nomEspeceResultant"
                  type="text"
                  label="Nom espèce résultant"
                ></v-text-field>

                <v-text-field
                  v-model="codeVarieteResultant"
                  type="text"
                  label="Code variété résultant"
                ></v-text-field>

                <v-text-field
                  v-model="nomVarieteResultant"
                  type="text"
                  label="Nom variété resultant"
                ></v-text-field>

                <v-select
                  v-model="instant"
                  :items="instantChoice"
                  label="Choix instant"
                  multiple
                ></v-select>

                <v-text-field
                  v-model="quantiteeSup"
                  type="number"
                  label="Quantité >="
                ></v-text-field>

                <v-text-field
                  v-model="quantiteeInf"
                  type="number"
                  label="Quantité <="
                ></v-text-field>

                <v-text-field
                  v-model="detail"
                  type="text"
                  label="Détail"
                ></v-text-field>

                <v-select
                  v-model="flagFige"
                  :items="figeChoice"
                  item-text="cle"
                  item-value="valeur"
                  label="Choix figé ou non"
                  multiple
                ></v-select>
              </v-layout>
            </td>
          </tr>
          <br />
        </template>
        <!-- <template v-slot:item.nomSite="{ item }">
          {{ item.nomSite.replaceAll('_', ' ') }}
        </template>
        <template v-slot:item.nomEspeceOrigine="{ item }">
          {{ item.nomEspeceOrigine.replaceAll('_', ' ') }}
        </template>
        <template v-slot:item.nomVarieteOrigine="{ item }">
          {{ item.nomVarieteOrigine.replaceAll('_', ' ') }}
        </template>
        <template v-slot:item.nomEspeceResultant="{ item }">
          {{ item.nomEspeceResultant.replaceAll('_', ' ') }}
        </template>
        <template v-slot:item.nomVarieteResultant="{ item }">
          {{ item.nomVarieteResultant.replaceAll('_', ' ') }}
        </template> -->
        <template v-slot:item.flagFige="{ item }">
          <v-icon>
            {{ item.flagFige ? 'fas fa-check' : 'fas fa-times' }}
          </v-icon>
        </template>
      </v-data-table>
      <v-btn class="mr-2 scdf-yellow" @click="figerSolCdec(1)"> FIGER </v-btn>
      <v-btn class="mr-2 scdf-yellow" @click="figerSolCdec(0)"> LIBERER </v-btn>
    </div>
    <div v-else>
      <v-overlay :z-index="zIndex" :value="overlay"
        ><spinner
          class="spinner-tab"
          :message="messageSpinner"
          :displayInfos="false"
      /></v-overlay>
    </div>
  </div>
</template>

<script>
import Spinner from '@/components/AppSpinner';

export default {
  name: 'figerSolCdec',
  components: {
    Spinner,
  },
  props: ['user'],
  data: function () {
    return {
      messageSpinner: 'Chargement des données',
      itemsSolCdec: null,
      selectedSolCdec: [],
      filteredItems: [],
      solCdecAvailable: false,
      options: {
        page: 1,
        itemsPerPage: 20,
        sortBy: [
          'codeSite',
          'codeVarieteOrigine',
          'codeVarieteResultant',
          'instant',
        ],
        sortDesc: [false, false, false, false],
        groupBy: [],
        groupDesc: [],
        mustSort: false,
        multiSort: true,
      },
      headersSolCdec: [
        {
          text: 'Code site',
          value: 'codeSite',
          align: 'center',
          filter: (f) => {
            return (f + '')
              .toLowerCase()
              .includes(this['codeSite'].toLowerCase());
          },
        },
        {
          text: 'Nom site',
          value: 'nomSite',
          align: 'center',
          filter: (f) => {
            return (f + '')
              .toLowerCase()
              .includes(this['nomSite'].replaceAll(' ', '_').toLowerCase());
          },
        },
        {
          text: 'Nom espèce origine',
          value: 'nomEspeceOrigine',
          align: 'center',
          filter: (f) => {
            return (f + '')
              .toLowerCase()
              .includes(
                this['nomEspeceOrigine'].replaceAll(' ', '_').toLowerCase()
              );
          },
        },
        {
          text: 'Code variété origine',
          value: 'codeVarieteOrigine',
          align: 'center',
          filter: (f) => {
            return (f + '')
              .toLowerCase()
              .includes(this['codeVarieteOrigine'].toLowerCase());
          },
        },
        {
          text: 'Nom variété origine',
          value: 'nomVarieteOrigine',
          align: 'center',
          filter: (f) => {
            return (f + '')
              .toLowerCase()
              .includes(
                this['nomVarieteOrigine'].replaceAll(' ', '_').toLowerCase()
              );
          },
        },
        {
          text: 'Nom espèce résultant',
          value: 'nomEspeceResultant',
          align: 'center',
          filter: (f) => {
            return (f + '')
              .toLowerCase()
              .includes(
                this['nomEspeceResultant'].replaceAll(' ', '_').toLowerCase()
              );
          },
        },
        {
          text: 'Code variété résultant',
          value: 'codeVarieteResultant',
          align: 'center',
          filter: (f) => {
            return (f + '')
              .toLowerCase()
              .includes(this['codeVarieteResultant'].toLowerCase());
          },
        },
        {
          text: 'Nom variété résultant',
          value: 'nomVarieteResultant',
          align: 'center',
          filter: (f) => {
            return (f + '')
              .toLowerCase()
              .includes(
                this['nomVarieteResultant'].replaceAll(' ', '_').toLowerCase()
              );
          },
        },
        {
          text: 'Instant',
          value: 'instant',
          align: 'center',
          filter: (o) => {
            return this.instant.length == 0 ? true : this.instant.includes(o);
          },
        },
        {
          text: 'Quantitée',
          value: 'quantitee',
          align: 'center',
          filter: (value) => {
            return (
              (this.quantiteeSup == '' ? true : value >= this.quantiteeSup) &&
              (this.quantiteeInf == '' ? true : value <= this.quantiteeInf)
            );
          },
        },
        {
          text: 'Détail',
          value: 'detail',
          align: 'center',
          filter: (f) => {
            return (f + '')
              .toLowerCase()
              .includes(this['detail'].toLowerCase());
          },
        },
        {
          text: 'Figé',
          value: 'flagFige',
          align: 'center',
          filter: (o) => {
            return this.flagFige.length == 0 ? true : this.flagFige.includes(o);
          },
        },
      ],
      codeSite: '',
      nomSite: '',
      nomEspeceOrigine: '',
      codeVarieteOrigine: '',
      nomVarieteOrigine: '',
      nomEspeceResultant: '',
      codeVarieteResultant: '',
      nomVarieteResultant: '',
      instant: [],
      quantiteeSup: '',
      quantiteeInf: '',
      detail: '',
      flagFige: [],
      instantChoice: [],
      figeChoice: [],
      overlay: true,
      zIndex: 999,
    };
  },
  created() {
    this.getSolCdec();
  },
  watch: {
    codeSite: function () {
      this.calculateFilteredItems();
    },
    nomSite: function () {
      this.calculateFilteredItems();
    },
    nomEspeceOrigine: function () {
      this.calculateFilteredItems();
    },
    codeVarieteOrigine: function () {
      this.calculateFilteredItems();
    },
    nomVarieteOrigine: function () {
      this.calculateFilteredItems();
    },
    nomEspeceResultant: function () {
      this.calculateFilteredItems();
    },
    codeVarieteResultant: function () {
      this.calculateFilteredItems();
    },
    nomVarieteResultant: function () {
      this.calculateFilteredItems();
    },
    instant: function () {
      this.calculateFilteredItems();
    },
    quantiteeSup: function () {
      this.calculateFilteredItems();
    },
    quantiteeInf: function () {
      this.calculateFilteredItems();
    },
    detail: function () {
      this.calculateFilteredItems();
    },
    flagFige: function () {
      this.calculateFilteredItems();
    },
    itemsSolCdec: function () {
      this.itemsSolCdec.forEach((element) => {
        if (!this.instantChoice.includes(element.instant)) {
          this.instantChoice.push(element.instant);
        }
      });
      this.figeChoice.push(
        { cle: 'Figé', valeur: 1 },
        { cle: 'Non Figé', valeur: 0 }
      );
    },
  },
  methods: {
    calculateFilteredItems() {
      const result = this.itemsSolCdec.filter((item) => {
        return (
          item.codeSite
            .toLowerCase()
            .includes(this['codeSite'].toLowerCase()) &&
          item.nomSite
            .toLowerCase()
            .includes(this['nomSite'].replaceAll(' ', '_').toLowerCase()) &&
          item.nomEspeceOrigine
            .toLowerCase()
            .includes(
              this['nomEspeceOrigine'].replaceAll(' ', '_').toLowerCase()
            ) &&
          item.codeVarieteOrigine
            .toLowerCase()
            .includes(this['codeVarieteOrigine'].toLowerCase()) &&
          item.nomVarieteOrigine
            .toLowerCase()
            .includes(
              this['nomVarieteOrigine'].replaceAll(' ', '_').toLowerCase()
            ) &&
          item.nomEspeceResultant
            .toLowerCase()
            .includes(
              this['nomEspeceResultant'].replaceAll(' ', '_').toLowerCase()
            ) &&
          item.codeVarieteResultant
            .toLowerCase()
            .includes(this['codeVarieteResultant'].toLowerCase()) &&
          item.nomVarieteResultant
            .toLowerCase()
            .includes(
              this['nomVarieteResultant'].replaceAll(' ', '_').toLowerCase()
            ) &&
          (this.instant.length == 0
            ? true
            : this.instant.includes(item.instant)) &&
          (this.quantiteeSup == ''
            ? true
            : this.quantiteeSup <= item.quantitee) &&
          (this.quantiteeInf == ''
            ? true
            : this.quantiteeInf >= item.quantitee) &&
          item.detail.toLowerCase().includes(this['detail'].toLowerCase()) &&
          (this.flagFige.length == 0
            ? true
            : this.flagFige.includes(item.flagFige))
        );
      });
      this.filteredItems = result;
    },
    handleToggleAll(event) {
      this.selectedSolCdec = event.value ? this.filteredItems : [];
    },
    toast(message) {
      this.snackbar = true;
      this.text = message;
    },
    async getSolCdec() {
      this.solCdecAvailable = false;
      axios({
        method: 'get',
        url: process.env.VUE_APP_BASE_URL + process.env.VUE_APP_GET_SOLCDEC,
        headers: {
          'Content-Type': 'application/json',
          user: this.user.email,
        },
      })
        .then((response) => {
          this.itemsSolCdec = response.data;
          this.filteredItems = response.data;
          this.solCdecAvailable = true;
        })
        .catch((error) => {
          this.itemsSolCdec = [];
          this.$emit(
            'message-response',
            'Erreur serveur lors du chagement des données',
            -1,
            true
          );
          this.solCdecAvailable = true;
        });
    },
    async figerSolCdec(aFiger) {
      this.solCdecAvailable = false;
      this.messageSpinner = 'Prise en compte de vos modifications en cours';
      let selected = this.selectedSolCdec;
      let idList = '';
      let size = selected.length;
      let i = 0;
      for (var key in selected) {
        i++;
        idList += i != size ? selected[key].id + ',' : selected[key].id;
      }
      axios({
        method: 'post',
        url: process.env.VUE_APP_BASE_URL + process.env.VUE_APP_FIGER_SOLCDEC,
        headers: {
          'Content-Type': 'application/json',
          user: this.user.email,
        },
        data: {
          idList: idList,
          flagFiger: aFiger,
        },
      })
        .then((response) => {
          this.$emit(
            'message-response',
            response.data.message,
            response.data.status,
            true
          );
          this.selectedSolCdec = [];
          this.getSolCdec();
        })
        .catch((error) => {
          this.$emit(
            'message-response',
            'Erreur du serveur lors de la modification des données',
            -1,
            true
          );
          this.solCdecAvailable = true;
        });
    },
    clearFilter() {
      this.codeSite = '';
      this.nomSite = '';
      this.nomEspeceOrigine = '';
      this.codeVarieteOrigine = '';
      this.nomVarieteOrigine = '';
      this.nomEspeceResultant = '';
      this.codeVarieteResultant = '';
      this.nomVarieteResultant = '';
      this.instant = [];
      this.quantiteeSup = '';
      this.quantiteeInf = '';
      this.detail = '';
      this.flagFige = [];
    },
  },
};
</script>

<style>
.scdf-yellow {
  margin-top: 10px;
}

.spinner-tab {
  margin-top: 30px;
}
</style>